module.exports = __webpack_public_path__ + "static/media/coach-1.8a7bccf5.jpg";